import { adminPageNames } from '../../shared/adminPageNames';

export const SELECT_CONNECTION_FOR_TRIAL_BALANCE_THRESHOLD = `${adminPageNames.TRIAL_BALANCE_THRESHOLD}/SELECT_CONNECTION`;

export const FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD = `${adminPageNames.TRIAL_BALANCE_THRESHOLD}/FETCH_CONNECTIONS`;
export const FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD_SUCCESS = `${adminPageNames.TRIAL_BALANCE_THRESHOLD}/FETCH_CONNECTIONS_SUCCESS`;
export const FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD_FAILURE = `${adminPageNames.TRIAL_BALANCE_THRESHOLD}/FETCH_CONNECTIONS_FAILURE`;
